import { useLocation, useNavigate, useParams } from "react-router-dom";
import err500 from "@lxp-app/assets/illustrations/500.svg";
import err404 from "@lxp-app/assets/illustrations/404.svg";
import err401 from "@lxp-app/assets/illustrations/401.svg";

import userNA from "@lxp-app/assets/png/user-NA.png";
import launchImage from "@lxp-app/assets/svg/Launching-pana.svg";
import AssessmentImage from "@lxp-app/assets/illustrations/internalassesment.svg";
import Button from "@lxp-app/components/atoms/button";
import { useDispatch } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import { useLazySendLoginActivityQuery } from "@lxp-app/store/slices/api/userInfoApiSlice";
import { UserInfoSliceActions } from "@lxp-app/store/slices/userInfoSlice";
import { AppMetaDataSliceActions } from "@lxp-app/store/slices/appMetaDataSlice";
import { useTranslation } from "react-i18next";

const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { type } = useParams();
  const { keycloak } = useKeycloak();

  const [sendLoginActivity] = useLazySendLoginActivityQuery();
  const dispatch = useDispatch();

  // const params = useParams();

  const loginAgain = () => {
    if (keycloak.authenticated) {
      sendLoginActivity("logout").then((res: any) => {
        dispatch(UserInfoSliceActions.setFirstTimeLogin(false));
        keycloak.logout({
          redirectUri: window.location.origin + "/"
        });
        sessionStorage.clear();
      });
    }
  };

  const getErrorUI = (type: string | undefined) => {
    switch (type) {
      case "service-unavailable":
        return (
          <div className="flex items-center justify-evenly lg:flex-row flex-col py-10">
            <div className="w-1/3">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={err500}
                alt="Error 500"
              />
            </div>
            <div className="w-2/3 flex flex-col items-center relative">
              <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] md:text-[10rem] text-[8rem] text-[#00875D] opacity-10	font-extrabold">
                500
              </div>
              <div>
                <div className="md:text-3xl text-2xl text-[#FF0000] font-medium">
                  {t("assessment.errorPage.serviceUnavailableTitle")}
                </div>
                <br />
                <div className="md:text-xl text-base font-normal">
                  {t("assessment.errorPage.troubleshootingIntro")}
                </div>
                <br />
                <br />
                <ul className="p-5 list-disc md:text-base text-sm font-normal">
                  <li className="mb-5">
                    {t("assessment.errorPage.serviceUnavailableStep1")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.serviceUnavailableStep2")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.serviceUnavailableStep3")}
                  </li>
                  <li className="list-none flex gap-x-5 justify-start">
                    <Button
                      variant={"contained"}
                      label={t("assessment.errorPage.goBack")}
                      onClick={() => navigate(-1)}
                      testId="errorGoBackBtn"
                    />
                    <Button
                      variant={"outlined"}
                      label={t("assessment.access.goToHome")}
                      onClick={() => navigate("/")}
                      testId="errorHomeBtn"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      case "page-not-found":
        return (
          <div className="flex items-center justify-evenly lg:flex-row flex-col py-10">
            <div className="w-1/3">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={err404}
                alt="Error 404"
              />
            </div>
            <div className="w-2/3 flex flex-col items-center relative">
              <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] md:text-[10rem] text-[8rem] text-[#00875D] opacity-10	font-extrabold">
                404
              </div>
              <div>
                <div className="md:text-3xl text-2xl text-[#FF0000] font-medium">
                  {t("assessment.errorPage.pageNotFoundTitle")}
                </div>
                <br />
                <div className="md:text-xl text-base font-normal">
                  {t("assessment.errorPage.troubleshootingIntro")}
                </div>
                <br />
                <br />
                <ul className="p-5 list-disc md:text-base text-sm font-normal">
                  <li className="mb-5">
                    {t("assessment.errorPage.pageNotFoundStep1")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.pageNotFoundStep2")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.pageNotFoundStep3")}
                  </li>
                  <li className="list-none flex gap-x-5 justify-start">
                    <Button
                      variant={"contained"}
                      label={t("assessment.errorPage.goBack")}
                      onClick={() => navigate(-1)}
                      testId="errorGoBackBtn"
                    />
                    <Button
                      variant={"outlined"}
                      label={t("assessment.access.goToHome")}
                      onClick={() => navigate("/")}
                      testId="errorHomeBtn"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      case "forbidden":
        return (
          <div className="flex items-center justify-evenly lg:flex-row flex-col">
            <div className="w-1/2">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={err401}
                alt="Error 401"
              />
            </div>
            <div className="lg:w-2/3 flex flex-col items-center relative">
              <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] md:text-[10rem] text-[8rem] text-[#00875D] opacity-10	font-extrabold">
                401
              </div>
              <div>
                <div className="md:text-3xl text-2xl text-[#FF0000] font-medium">
                  {t("assessment.errorPage.forbiddenTitle")}
                </div>
                <br />
                <div className="md:text-xl text-base font-normal">
                  {t("assessment.errorPage.troubleshootingIntro")}
                </div>
                <br />
                <br />
                <ul className="p-5 list-disc md:text-base text-sm font-normal">
                  <li className="mb-5">
                    {t("assessment.errorPage.forbiddenStep1")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.forbiddenStep2")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.forbiddenStep3")}
                  </li>
                  <li className="list-none flex gap-x-5 justify-start">
                    <Button
                      variant={"contained"}
                      label={t("assessment.errorPage.raiseRequest")}
                      onClick={(e) => {
                        window.open(
                          "https://globallogic.atlassian.net/servicedesk/customer/portal/30/group/344",
                          "_blank"
                        );
                        e.preventDefault();
                      }}
                      testId="errorGoBackBtn"
                    />
                    <Button
                      variant={"outlined"}
                      label={t("assessment.access.goToHome")}
                      onClick={() => navigate("/")}
                      testId="errorHomeBtn"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      case "user-not-found":
        return (
          <div className="flex items-center justify-center lg:flex-row flex-col h-full">
            <div className="w-1/2">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={userNA}
                alt="Error User Not Found"
              />
            </div>
            <div className="lg:w-2/3 flex flex-col items-center relative">
              <div>
                <div className="md:text-3xl text-2xl text-[#FF0000] font-medium">
                  {t("assessment.errorPage.userNotFoundTitle")}
                </div>
                <br />
                <div className="md:text-xl text-base font-normal">
                  {t("assessment.errorPage.troubleshootingIntro")}
                </div>
                <br />
                <br />
                <ul className="p-5 list-disc md:text-base text-sm font-normal">
                  <li className="mb-5">
                    {t("assessment.errorPage.userNotFoundStep1")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.userNotFoundStep2")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.userNotFoundStep3")}
                  </li>
                  <li className="list-none flex gap-x-5 justify-start">
                    <Button
                      variant={"contained"}
                      label={t("assessment.errorPage.retryLogin")}
                      onClick={() => loginAgain()}
                      testId="errorGoBackBtn"
                    />
                    <Button
                      variant={"outlined"}
                      label={t("assessment.errorPage.contactUs")}
                      onClick={(e) => {
                        window.open(
                          "https://globallogic.atlassian.net/servicedesk/customer/portal/30/group/344",
                          "_blank"
                        );
                        e.preventDefault();
                      }}
                      testId="errorHomeBtn"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );

        dispatch(AppMetaDataSliceActions.setViewHeader(false));
        dispatch(AppMetaDataSliceActions.setViewFooter(false));
        dispatch(AppMetaDataSliceActions.setViewBreadcrumb(false));
        return (
          <div className="flex items-center justify-center flex-col py-10">
            <div className="w-1/5 mb-8">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={launchImage}
                alt="launchImage"
                className=""
              />
            </div>
            <div className="text-xl mb-10">
              {t("assessment.errorPage.courseClosedMessage")}
            </div>
            <Button
              variant={"contained"}
              label={t("assessment.errorPage.launchCourse")}
              onClick={() => navigate(-2)}
              testId="errorGoBackBtn"
            />
          </div>
        );
      case "assessment-finish":
        dispatch(AppMetaDataSliceActions.setViewHeader(false));
        dispatch(AppMetaDataSliceActions.setViewFooter(false));
        dispatch(AppMetaDataSliceActions.setViewBreadcrumb(false));
        return (
          <div className="flex items-center justify-center flex-col py-10">
            <div className="w-1/5 mb-8">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={AssessmentImage}
                alt="launchImage"
                className=""
              />
            </div>
            <div className="text-xl mb-10">
              {t("assessment.errorPage.assessmentCompletedMessage")}
            </div>
          </div>
        );

      default:
        return (
          <div className="flex items-center justify-evenly lg:flex-row flex-col">
            <div className="w-1/3">
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                src={err404}
                alt=""
              />
            </div>
            <div className="w-2/3 flex flex-col items-center relative">
              <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] md:text-[10rem] text-[8rem] text-[#00875D] opacity-10	font-extrabold">
                404
              </div>
              <div>
                <div className="md:text-3xl text-2xl text-[#FF0000] font-medium">
                  {t("assessment.errorPage.pageNotFoundTitle")}
                </div>
                <br />
                <div className="md:text-xl text-base font-normal">
                  {t("assessment.errorPage.troubleshootingIntro")}
                </div>
                <br />
                <br />
                <ul className="p-5 list-disc md:text-base text-sm font-normal">
                  <li className="mb-5">
                    {t("assessment.errorPage.pageNotFoundStep1")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.pageNotFoundStep2")}
                  </li>
                  <li className="mb-5">
                    {t("assessment.errorPage.pageNotFoundStep3")}
                  </li>
                  <li className="list-none flex gap-x-5 justify-start">
                    <Button
                      variant={"contained"}
                      label={t("assessment.errorPage.goBack")}
                      onClick={() => navigate(-1)}
                      testId="errorGoBackBtn"
                    />
                    <Button
                      variant={"outlined"}
                      label={t("assessment.access.goToHome")}
                      onClick={() => navigate("/")}
                      testId="errorHomeBtn"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="md:my-10 px-3 sm:px-5 md:px-9 xl:px-16 xl:mx-1 h-full">
        {getErrorUI(type)}
      </div>
    </>
  );
};

export default ErrorPage;
